import React from 'react';
import { useTranslation } from 'react-i18next';

import { IAuth } from '@/modules/auth/types';
import ProgressBar from '@/modules/settings/approvals/components/shared/ProgressBar';
import { Typography } from '@/shared/components/atoms';
import ScrollableWithShadow from '@/shared/components/atoms/ScrollableWithShadow';

const StepContainer = ({
  step,
  stepsCount,
}: {
  step: IAuth.IStepSchema;
  stepsCount: number;
}) => {
  const { t } = useTranslation('common');
  const { idx, render, title } = step;

  return (
    <div>
      <ProgressBar step={step.idx} stepsNumber={stepsCount} />
      <div className='py-24 px-24 desktop:px-148'>
        <Typography variant='caption' className='text-surface-10'>
          {t('step')} {idx} {t('of')} {stepsCount}
        </Typography>
        <Typography weight='bold' variant='h6'>
          {title}
        </Typography>
        <ScrollableWithShadow
          className='mt-32'
          maxHeight='max-h-[57vh]'
          bgColor='light-grey'
        >
          {render()}
        </ScrollableWithShadow>
      </div>
    </div>
  );
};

export { StepContainer };
